import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Button, Card } from "@/components/primitives";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";

export function CallbackPage() {
  const navigate = useNavigate();
  const auth = useAihrAuth();

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      void navigate({ to: "/" });
    }
  }, [auth.isAuthenticated, auth.isLoading, navigate]);

  if (auth.error) {
    return (
      <div className="center-screen">
        <Card className="signin-card">
          <h1>Sign in failed</h1>
          <p>{auth.error.message}</p>
          <Button onClick={() => void auth.login()}>Try again</Button>
        </Card>
      </div>
    );
  }

  if (!auth.isLoading && !auth.isAuthenticated) {
    return (
      <div className="center-screen">
        <Card className="signin-card">
          <h1>Sign in incomplete</h1>
          <p>Auth0 did not complete the sign-in flow.</p>
          <Button onClick={() => void auth.login()}>Sign in again</Button>
        </Card>
      </div>
    );
  }

  return <div className="center-screen">Completing sign in...</div>;
}
